import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Whychoosewebapp() {
  return (
    <section
      className="why_choose_webapp p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose TekRevol for <span>Web Development</span> in the UK?
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              TekRevol consistently delivers outstanding outcomes for clients
              worldwide. Our portfolio showcases our commitment to excellence
              and deep understanding of global market trends. We craft bespoke
              solutions tailored to your unique business objectives, ensuring
              peak website performance post-launch. As a leading web design and
              development company in the UK, we embrace innovation to enhance
              your online presence.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="why-choose-web-main">
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">01</div>
                  <div className="why-choose-content">
                    <h5>Advanced UX/UI Engineering</h5>
                    <p>
                      Maximise user interaction with precision-crafted
                      interfaces and intuitive design flows.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">02</div>
                  <div className="why-choose-content">
                    <h5>Scalable Architecture</h5>
                    <p>
                      Support your business growth with scalable frameworks
                      built for high performance.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">03</div>
                  <div className="why-choose-content">
                    <h5>Mobile-First Optimisation</h5>
                    <p>
                      Lead in mobile markets with designs that adapt perfectly
                      to any screen size.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">04</div>
                  <div className="why-choose-content">
                    <h5>Enterprise-Grade Security</h5>
                    <p>
                      Secure your data with robust, multi-layered security
                      solutions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">05</div>
                  <div className="why-choose-content">
                    <h5>Custom API Integrations</h5>
                    <p>
                      Integrate seamlessly with custom APIs designed for your
                      unique business needs.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">06</div>
                  <div className="why-choose-content">
                    <h5>High-Performance Code</h5>
                    <p>
                      Enhance speed and SEO with lean, optimised code for
                      superior site performance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosewebapp;
